import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { interval } from 'rxjs';
import { debounce, debounceTime } from 'rxjs/operators';
import { ObjetosService } from 'src/app/core/http/apiProducto/objetos.service';
import { IInvoiceContract } from 'src/app/core/interfaces/shared/bundle/IInvoiceContract';
import { GlobalDialogComponent } from '../../globaldialog/globaldialog.component';

@Component({
  selector: 'app-pay-contract-form', templateUrl: './pay-contract-form.component.html',
  styleUrls: ['./pay-contract-form.component.scss'],
})
export class PayContractFormComponent implements OnInit {

  @Input('data') invoiceFormData: IInvoiceContract = {
    factura: null,
  };

  @Input() finishButton:boolean = true

  @Input() autorizada:boolean = false

  invoiceForm = new FormGroup({
    factura: new FormControl(this.invoiceFormData.factura, [
      Validators.required,
    ]),
  });

  get factura() {
    return this.invoiceForm.get('factura');
  }

  @Output() emitFormInvoiceData = new EventEmitter<IInvoiceContract>();
  @Output() emitFinishButton = new EventEmitter<boolean>();

  keyTranslate: string = 'clientContracts.forms.payContractForm';
  sendButton: boolean = false;

  constructor(
    private dialog: MatDialog,
    private objetosService: ObjetosService
    ) {}

  ngOnInit(): void {
    this.saveDataInvoiceForm();
    this.invoiceForm.patchValue(this.invoiceFormData, {
      onlySelf: true,
      emitEvent: false,
    });
  }

  saveDataInvoiceForm() {
    this.invoiceForm.valueChanges.pipe(debounceTime(1000)).subscribe((formData) => {
      this.emitFormInvoiceData.emit(null);
      console.log("Invoice changed", formData);
      if (this.invoiceForm.valid) {
        this.emitFormInvoiceData.emit(formData);
      }
    });
  }

  InfoPayDialog() {

    this.objetosService.getCoverageInfoTextByPantallaInfo('PagoPdv').subscribe(res=>{

      const dialogRef = this.dialog.open(GlobalDialogComponent, {
        disableClose: true,
        panelClass: 'clientInfoPopup-panel',
        data: {
          title: '¿Como realizo el pago?',
          subtitle: res.data[0].descPantallaSeccion,
          closeIcon: true
        },
    })

    });
  }
}
